import { render, staticRenderFns } from "./ModListUserBodyRolesComp.vue?vue&type=template&id=55c23aa3&scoped=true&"
import script from "./ModListUserBodyRolesComp.vue?vue&type=script&lang=ts&"
export * from "./ModListUserBodyRolesComp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c23aa3",
  null
  
)

export default component.exports